// https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa
// convert a Unicode string to a string in which
// each 16-bit unit occupies only one byte
function toBinary(pString: string) {
    const codeUnits = new Uint16Array(pString.length);
    for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = pString.charCodeAt(i);
    }
    return String.fromCharCode(...new Uint8Array(codeUnits.buffer));
}

function fromBinary(pBinary: string) {
    const bytes = new Uint8Array(pBinary.length);
    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = pBinary.charCodeAt(i);
    }
    return String.fromCharCode(...new Uint16Array(bytes.buffer));
}

export function toBase64(pString: string) {
    const converted = toBinary(pString);
    const encoded = btoa(converted);
    return encoded;
}

export function fromBase64(pString: string) {
    const decoded = atob(pString);
    const original = fromBinary(decoded);
    return original;
}